<template>
	<div class="asktry_form">
		<!-- 预约试驾 -->
			<van-popup
				:closeOnClickOverlay="false"
				class="applyform-content askpricevlog"
				v-model="showTryform"
				position="bottom"
				round
				:showConfirmButton="false"
				:style="{ height: '370px' }"
			>
			<div class="title">预约试驾</div>
			<van-form @submit="onSubmitApply">
				<van-field style="margin-top: 10px" border v-model="tryforminfo.name" minlength="2" maxlength="6" name="用户名" placeholder="您的姓名" />
				<van-field style="margin-top: 10px" border v-model="tryforminfo.mobile" name="手机号" maxlength="11" placeholder="请输入手机号码" />
				<van-field
					style="margin-top: 10px"
					border
					v-model="areaval"
					readonly
					clickable
					name="地区"
					@click="showQueryArea = true"
					placeholder="购机区域"
				/>
				<van-field
					style="margin-top: 10px"
					border
					v-model="productval"
					readonly
					clickable
					name="产品"
					@click="showSelect = true"
					placeholder="选择产品"
				/>
				<div>
					<van-button native-type="submit" class="button">提交试驾</van-button>
				</div>
			</van-form>
			<div class="applyformdelicon" @click="closeshowTryform"><van-icon name="cross"  /></div>
		</van-popup>

		<van-popup v-model="showQueryArea" position="bottom">
			<van-area :area-list="areaList" @confirm="onConfirm" @cancel="showQueryArea = false" />
		</van-popup>

		<van-popup v-model="showSelect" round position="bottom">
			<van-picker title="标题" show-toolbar :columns="productColumns" @cancel="showSelect = false" @confirm="onConfirmType">
				<template #option="option">
					{{ option.name }}
				</template>
			</van-picker>
		</van-popup>

	</div>
</template>

<script>
import * as api from "@/api/live";
import { areaList } from "@vant/area-data";
import { checkMobile, checkName } from "@/utils/utils.js";
export default {
	data() {
		return {
			showQueryArea:false,
			areaList,
			areaval:'',
			showform:false,
			productColumns: [],
			showSelect:false,
			productval:'',
			tryforminfo:{
				name: "",
				mobile: "",
				province: "",
				city: "",
				area: "",
				product_id: "",
				user_id: "",
			},
	
		};
	},
	props: {

		goodsList:{
			type: Array,
			default:[],
		},
		showTryform:{
			type: Boolean,
			default:false,
		},
		userId:{
			type: [String, Number],
			default: "",
		},
		live_id:{
			type: [String, Number],
			default: "",
		},
		
	},
	watch:{
		goodsList(newV,oldV){
			this.productColumns = this.goodsList.filter((item) => {
				return item.is_new == 2
			});
		}
	},
	mounted() {
		
	},
	methods: {
		closeshowTryform(){
			this.$emit('closeshowTryform')
		},
		onConfirm(values) {
			this.areaval = values
				.filter((item) => !!item)
				.map((item) => item.name)
				.join("/");
			this.tryforminfo.province = values[0].name;
			this.tryforminfo.city = values[1].name;
			this.tryforminfo.area = values[2].name;
			this.showQueryArea = false;
		},
		onConfirmType(value){
			this.productval = value.name
			this.tryforminfo.product_id = value.id
			this.showSelect = false
		},
		//提交
		onSubmitApply(values) {
			if (this.tryforminfo.name == "") {
				this.$toast({
					message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写姓名</div>',
					type: "html",
				});
				return;
			}

			if (this.tryforminfo.name != "" && !checkName(this.tryforminfo.name)) {
				this.$toast({
					message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写2-6位汉字姓名</div>',
					type: "html",
				});
				return;
			}
			if (this.tryforminfo.mobile == "") {
				this.$toast({
					message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写手机号</div>',
					type: "html",
				});
				return;
			}
			if (this.tryforminfo.mobile != "" && !checkMobile(this.tryforminfo.mobile)) {
				this.$toast({
					message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请填写正确手机号</div>',
					type: "html",
				});
				return;
			}
		
			if (this.areaval == "") {
				this.$toast({
					message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请选择地区</div>',
					type: "html",
				});
				return;
			}
			
			if (this.productval == "") {
				this.$toast({
					message: '<div style="height:40px;with:70px;display:flex;align-items:center;justified-content:center">请选择商品型号</div>',
					type: "html",
				});
				return;
			}
			this.tryforminfo.live_id = this.live_id;
			this.tryforminfo.user_id = this.userId;
			this.tryforminfo.type = 2
			api.goodsEnquiry(this.tryforminfo).then((res) => {
				this.codeTime = 60;
				if (res.code != 200) {
					this.$toast(res.message);
				}
				this.$toast.success("预约成功");
				this.$emit('closeshowTryform')
				this.tryforminfo = {
					name: "",
					mobile: "",
					province: "",
					city: "",
					area: "",
					product_id: "",
					user_id: "",
				};
				this.areaval = "";
				this.productval = ''

			});
		
			
		},

	},
};
</script>

<style lang="less" scoped>
	@import "../assets/styles/askform.less";

</style>
